import * as React from 'react';
import { IconProps } from '../../dto/Interfaces/IIconProps';

const Google: React.FC<IconProps> = ({ color, size, style }) => {
  return (
    <svg style={style} width={size ?? '20'} height={size ?? '21'} fill="none" viewBox="0 0 20 21" data-testid="google-icon">
      <path
        fill={color ?? '#FFC107'}
        d="M18.17 8.768h-.67v-.034H10v3.333h4.709a4.998 4.998 0 01-9.71-1.667 5 5 0 015-5c1.275 0 2.434.481 3.317 1.267l2.357-2.357A8.295 8.295 0 0010 2.067a8.334 8.334 0 108.172 6.701z"
      />
      <path
        fill={color ?? '#FF3D00'}
        d="M2.627 6.522L5.365 8.53A4.998 4.998 0 019.999 5.4c1.275 0 2.435.481 3.317 1.267l2.358-2.357a8.295 8.295 0 00-5.675-2.243 8.329 8.329 0 00-7.372 4.455z"
      />
      <path
        fill={color ?? '#4CAF50'}
        d="M10 18.734a8.294 8.294 0 005.588-2.164l-2.58-2.182a4.962 4.962 0 01-3.007 1.012A4.998 4.998 0 015.3 12.09l-2.718 2.093a8.327 8.327 0 007.419 4.55z"
      />
      <path
        fill={color ?? '#1976D2'}
        d="M18.171 8.768H17.5v-.034H10v3.333h4.71a5.017 5.017 0 01-1.703 2.321l2.58 2.182c-.182.166 2.746-2.003 2.746-6.17 0-.558-.057-1.104-.162-1.632z"
      />
    </svg>
  );
};

export default Google;
